// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b2176da5","453":"ae5a6623","796":"825efacb"}[chunkId] + ".chunk.js";
};